export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;
export const STRIPE_PUBLISH_KEY = import.meta.env.VITE_STRIPE_PUBLIC_KEY;
export const VITE_PAR_CHILD_WEBSITE_LINK = import.meta.env
  .VITE_PAR_CHILD_WEBSITE_LINK;
